import React, {useState, useEffect, useRef} from 'react';
import PauseIcon from '../icons/Pause.svg'
import PrevIcon from '../icons/Prev.svg'
import NextIcon from '../icons/Next.svg'
import PlayIcon from '../icons/Play.svg'
import QRCode from "react-qr-code";
import Minimize from '../icons/Minimize.svg'
import FullScreen from '../icons/FullScreen.svg'
import useWindowDimentions from '../hooks/useWindowDimentions'
import { useSelector } from 'react-redux';
import screenfull from "screenfull"
import ProgressSlider from './ProgressSlider';
import SoundIcon from '../icons/Sound.svg'
import MuteIcon from '../icons/Mute.svg'
import Min from '../icons/Min.svg'
import Max from '../icons/Max.svg'
import BottomPlaylists from './BottomPlaylists';
import AnalyzeButton from './AnalyzeButton'
import BottomTracks from './BottomTracks';
import { formatSeconds } from '../../utils/formatTime';


const PlayerOverlay = (props) => {

    const { watermark_info } = useSelector(state=>state.analyze_info)
    const [full, setFull] = useState(false)
    const {width, height} = useWindowDimentions()
    const [qr, setQr] = useState(false)
    const [qualityVisible, setQualityVisible] = useState(false)
    const qualityRef = useRef()

    useEffect(()=>{
        const identifier = setTimeout(() => {
            setQr(!qr)
        }, 15000);

        return () => {
            clearTimeout(identifier)
        }

      },[qr])



    function exitHandler() {
        if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
            setFull(false)
        }
      }

    if (document.addEventListener) {
        document.addEventListener('webkitfullscreenchange', exitHandler, false);
        document.addEventListener('mozfullscreenchange', exitHandler, false);
        document.addEventListener('fullscreenchange', exitHandler, false);
        document.addEventListener('MSFullscreenChange', exitHandler, false);
    }


    const toggleFullScreen = (ref) => {
        if (props.playerContainerRef && props.playerContainerRef.current){
          screenfull.toggle(props.playerContainerRef.current)
          setFull(!full)
        }
    }


    const onChangeBitrate = (id) => {
        const internalPlayer = props.playerRef.current?.getInternalPlayer('hls');
        if (internalPlayer) {
            // currentLevel expect to receive an index of the levels array
            internalPlayer.currentLevel = id;
            props.setQuality(props.playerRef.current?.getInternalPlayer('hls')?.levels[id].height)
            setQualityVisible(false)
        }
    }

    return (
        <div className='position-absolute w-100 h-100' style={{zIndex:100}} onClick={()=>props.setPlaying(!props.playing)}>
            {
                width < 990 &&
                <div className='w-100 h-100 position-absolute'>
                    {
                        window.innerWidth > window.innerHeight &&
                        <div
                            className= {!props.playing || props.menuVisible ?
                                'd-flex justify-content-end visible pl-landscape-top-row' :
                                'd-flex justify-content-end hidden pl-landscape-top-row'}
                        >
                            {
                                full ?
                                <img
                                    className='pl-icon-landscape-toggle'
                                    style={{zIndex:"1000"}}
                                    src = {Min}
                                    alt = ""
                                    onClick={
                                        (e)=>{
                                            e.stopPropagation();
                                            toggleFullScreen(props.playerContainerRef)
                                        }
                                        }
                                /> :
                                <img
                                    className='pl-icon-landscape-toggle'
                                    src = {Max}
                                    alt = ""
                                    style={{zIndex:"1000"}}
                                    onClick={
                                        (e)=>{
                                            e.stopPropagation();
                                            toggleFullScreen(props.playerContainerRef)
                                        }
                                    }
                                />
                            }
                        </div>
                    }
                    <div className =
                    {!props.playing || props.menuVisible ?
                        'position-absolute col-4 d-flex justify-content-center align-items-center visible pl-center-controls' :
                        'position-absolute col-4 d-flex justify-content-center align-items-center hidden pl-center-controls'}

                        style={{top:"50%", left:"50%", transform:"translate(-50%, -50%)"}}>
                        <img className='pl-icon-nav' src = {PrevIcon} alt = '' role = 'button' onClick={props.prevHandler}/>
                        {
                            props.playing ?
                            <div role = "button" onClick={()=>props.setPlaying(false)}><img className='pl-icon-play' src = {PauseIcon} alt = ''/></div> :
                            <div role = "button" onClick={()=>props.setPlaying(true)}><img className='pl-icon-play' src = {PlayIcon} alt = ''/></div>
                        }
                        <img className='pl-icon-nav' src = {NextIcon} alt = '' role = 'button' onClick={props.endHandler}/>
                    </div>
                </div>

            }
            <div className='position-relative w-100 h-100 d-flex flex-column justify-content-end justify-content-md-between'>
                {
                    full ? watermark_info && watermark_info.result_link && width > 990?
                        <div className={
                            !props.playing || qr ?
                            'rounded visible position-relative':
                            'rounded hidden position-relative'}
                            style={{ width:"128px", top:"30px", left:"30px", height: "auto", background:"white", padding:"0.35vw"}}
                        >
                        <QRCode
                            size={256}
                            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                            value={props.video && props.video.id === 1386 ? 'https://shop.rewe.de/p/nutella-750g/5095220' : watermark_info.result_link}
                            viewBox={`0 0 256 256`}
                        />
                    </div> : <div></div> :
                    width > 990 ?
                    <AnalyzeButton
                        handleRewind = {props.handleRewind}
                        analyzeRef = {props.analyzeRef}
                        video = {props.video}/> : <div></div>
                    }

                <div className='position-relative'>
                    {
                        width > 990 && (
                            props.playing && props.video && props.video.tracks && props.video.tracks.length > 1 ?
                            "" :
                            <BottomPlaylists
                                playing = {props.playing}
                                menuVisible = {props.menuVisible}
                                searchParams = {props.searchParams}
                                setSearchParams = {props.setSearchParams}
                                video = {props.video}
                                setPlaying = {props.setPlaying}
                                width = {width}
                                videoClickHandler = {props.videoClickHandler}
                            />
                        )
                    }

                    {
                        props.video && props.video.tracks && props.video.tracks.length > 1 ?
                        <BottomTracks
                            playing = {props.playing}
                            width = {width}
                            video = {props.video}
                            activeTrack = {props.activeTrack}
                            trackClickHandler = {props.trackClickHandler}
                            tracksRef = {props.tracksRef}
                            menuVisible = {props.menuVisible}
                        /> :''
                    }

                    {
                        qualityVisible &&
                        <div
                            ref = {qualityRef}
                            className = 'bg-secondary position-absolute d-flex flex-column align-items-center px-1 py-1 rounded'
                            style={{zIndex:"200", right:"35px", bottom:"70px"}}
                            onClick={(e)=>e.stopPropagation()}
                            >
                            {props.playerRef.current?.getInternalPlayer('hls')?.levels.map(
                                (level, id) =>
                                <div className = 'fw-bold px-2 px-md-4 py-0 py-md-1 rounded quality-styles'
                                style={props.quality === level.height ? {color:'white'} : {color:"#00C8D5"}}
                                    role='button'
                                    key={id}
                                    onClick={()=>onChangeBitrate(id)}
                                    value={id}
                                    >
                                    {level.height + 'p'}
                                </div>
                            )}
                        </div>
                    }
                    <div
                        className = 'position-relative w-100 bottom-0'
                        onClick={(e)=>e.stopPropagation()}
                        style={props.menuVisible || !props.playing ? {backgroundColor:"#07294C80"}:{}}
                        >
                        <div className = 'w-100 position-relative' >
                            <div className={!props.playing || props.menuVisible ? 'w-100 visible px-1': "hidden"}
                                style={{}}>
                                <ProgressSlider
                                    onChange = {props.onVideoChange}
                                    progress = {props.videoProgress}
                                    height = {'4px'}
                                    setActiveTrack = {props.setActiveTrack}
                                />
                            </div>
                        </div>
                        <div className = {!props.playing || props.menuVisible ?
                            'w-100 position-relative d-flex justify-content-between align-items-center visible pl-controls-row'
                            : 'w-100 position-relative d-flex justify-content-between align-items-center hidden pl-controls-row' }
                            >
                            <div className = {'col-4 d-flex justify-content-start align-items-center'}>
                                {
                                    props.muted ?
                                    <img className='pl-icon-sound' src = {MuteIcon} alt = '' onClick={()=>props.setMuted(false)}/> :
                                    <img className='pl-icon-sound' src = {SoundIcon} alt = '' onClick={()=>props.setMuted(true)}/>
                                }
                                <div className={'visible px-1'} style={{width:'100px'}}>
                                    <ProgressSlider
                                        onChange = {props.onSoundChange}
                                        progress = {props.soundProgress}
                                        height = {'2px'}
                                    />
                                </div>
                                <div className={'px-2 visible d-flex justify-content-between pl-time-text'} style={{width:`${props.timeDisplay.length*23}px`}}>
                                    <div className='col-5 text-white text-start m-0'>
                                        {props.timeDisplay}
                                    </div>
                                    <div className='col-2 text-white px-1 '>
                                        |
                                    </div>
                                    <div className='col-5 text-white ps-1 text-start m-0'>
                                        {props.video && props.video.duration ? formatSeconds(props.video.duration) : "00:00"}
                                    </div>
                                </div>
                            </div>
                            {
                                width > 990 &&
                                <div
                                    className='col-4 d-flex justify-content-center align-items-center pl-center-controls'
                                    onClick={(e)=>e.stopPropagation()}
                                    >
                                    <img className='pl-icon-nav' src = {PrevIcon} alt = '' role = 'button' onClick={props.prevHandler}/>
                                    {
                                        props.playing ?
                                        <div role = "button" onClick={()=>props.setPlaying(false)}><img className='pl-icon-play' src = {PauseIcon} alt = ''/></div> :
                                        <div role = "button" onClick={()=>props.setPlaying(true)}><img className='pl-icon-play' src = {PlayIcon} alt = ''/></div>
                                    }
                                    <img className='pl-icon-nav' src = {NextIcon} alt = '' role = 'button' onClick={props.endHandler}/>
                                </div>
                            }
                            <div className = 'col-4 d-flex align-items-center justify-content-end'>
                                <div className = 'px-2'>
                                   {
                                    props.quality &&
                                    <div
                                        onClick={(e)=>{e.stopPropagation(); setQualityVisible(!qualityVisible)}}
                                        className = 'text-white px-2 pl-time-text'
                                        role = 'button'
                                        style={{background:'transparent', appearance:"none", border:"none"}}>
                                            {props.quality + 'p'}
                                    </div>
                                   }
                                </div>
                                {
                                    full ?
                                    <div className={!props.playing || props.menuVisible ? 'visible' : ' hidden'}
                                        role = 'button'
                                        onClick={()=>toggleFullScreen(props.playerContainerRef)}
                                        >
                                            <img className='pl-icon-minimize' src = {Minimize} alt = ''/>
                                        </div> :
                                        <div className={!props.playing || props.menuVisible ? 'visible' : 'hidden'}
                                            role='button'
                                            onClick={()=>toggleFullScreen(props.playerContainerRef)}
                                        >
                                        <img className='pl-icon-fullscreen' src = {FullScreen} alt = ''/>
                                    </div>
                                }

                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlayerOverlay;